import {
    buildListParams,
    getListData,
    getTotalRecords,
    handleListDeleteIconMouseEnter,
    handleListIconMouseEnter,
    handleListIconMouseLeave,
    listStyles,
    loadStoredJson,
    removeStoredKeys,
    saveStoredValue
} from 'lib/listUtils';
import {
    Box,
    Button,
    Card,
    CardContent,
    Input,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip
} from '@material-ui/core';
import {
    BackspaceOutlined,
    DeleteForeverOutlined,
    EditTwoTone,
    Search,
    VisibilityOutlined
} from '@material-ui/icons';
import api from 'services/api';
import { ANAO, ASIM } from 'consts';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import { safeSetState } from 'lib/reactUtils';
import { getResponseData } from 'lib/formUtils';
import { ComboPadraoMultiple } from 'views/Components';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { AlertInformation, DeleteConfirmationModal } from 'components';

class FuncionarioList extends Component {
    state = {
        searchFilter: loadStoredJson('funcionarioSearchFilter', {
            nome: '',
            situacaoInativoFilter: ANAO,
            cargos: []
        }),
        funcionarios: [],
        listaCargos: [],
        open: false,
        openAlert: false,
        messageAlert: '',
        selectedId: null,
        selectedDesc: null,
        totalItems: 0,
        page: Number(sessionStorage.getItem('funcionarioPage')) || 0,
        rowsPerPage: Number(sessionStorage.getItem('funcionarioRowsPerPage')) || 10
    };

    estilo = listStyles;

    _isMounted = false;

    handleIconMouseEnter = handleListIconMouseEnter;
    handleIconMouseLeave = handleListIconMouseLeave;
    handleDeleteIconMouseEnter = handleListDeleteIconMouseEnter;
    safeSetState = safeSetState;

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        this._isMounted = true;

        await this.loadCargosFiltro();

        this.loadFuncionarios();
    };

    /* Paginação */
    componentDidUpdate(prevProps, prevState) {
        const { page, rowsPerPage, searchFilter } = this.state;

        // persiste os filtros e a paginação no sessionStorage
        if (prevState.searchFilter !== searchFilter) {
            saveStoredValue('funcionarioSearchFilter', searchFilter);
        }

        if (prevState.page !== page) {
            saveStoredValue('funcionarioPage', page);
        }

        if (prevState.rowsPerPage !== rowsPerPage) {
            saveStoredValue('funcionarioRowsPerPage', rowsPerPage);
        }
    };

    /* Limpa os filtros e a paginação ao sair da tela */
    componentWillUnmount() {
        this._isMounted = false;

        removeStoredKeys([
            'funcionarioSearchFilter',
            'funcionarioPage',
            'funcionarioRowsPerPage'
        ]);
    };

    /* Carrega os cargos pro filtro */
    loadCargosFiltro = async () => {
        try {
            const response = await api.get('/cargo');
            const cargos = getResponseData(response);

            const listaCargos = cargos.map(cargo => ({
                id: cargo.codcargo,
                item: cargo.cargo
            }));

            this.safeSetState({ listaCargos });
        } catch (error) {
            console.error('Erro ao carregar os cargos:', error);
        }
    };

    /* Carrega os funcionários */
    loadFuncionarios = async () => {
        const { searchFilter, page, rowsPerPage } = this.state;
        const { cargos, nome, situacaoInativoFilter } = searchFilter;

        const filtros = [
            {
                field: 'NOME',
                value: nome,
                operator: '_like_'
            },
            {
                field: 'INATIVO',
                value: situacaoInativoFilter
            }
        ];

        if (cargos && cargos.length > 0) {
            const codigoCargos = cargos.map(c => c.id);

            filtros.push({
                field: 'CODCARGO',
                value: codigoCargos.join(','),
                operator: '_in_'
            });
        }

        const params = buildListParams({
            page,
            rowsPerPage,
            filters: filtros
        });

        try {
            const response = await api.get('/funcionario' + params);

            this.safeSetState({
                funcionarios: getListData(response),
                totalItems: getTotalRecords(response)
            });
        } catch (error) {
            console.error('Erro ao carregar os funcionários:', error);

            this.safeSetState({
                funcionarios: [],
                totalItems: 0
            });
        }
    };

    /* Muda a página */
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, this.loadFuncionarios);
    };

    /* Muda a quantidade de retornos por página */
    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        }, this.loadFuncionarios);
    };

    /* Deleta o funcionário */
    handleDelete = async (id) => {
        try {
            const response = await api.delete(`/funcionario/${id}`);

            // verifica se a exclusão foi bem-sucedida
            if (response.status === 200) {
                this.handleClose();
                this.loadFuncionarios();
            }
        } catch (error) {
            this.handleClose();

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao excluir funcionário!'
            );
        }
    };

    /* Confirma a exclusão */
    handleConfirmDelete = () => {
        const { selectedId } = this.state;

        this.handleDelete(selectedId);
    };

    /* Abre a janela de confirmação para a exclusão */
    handleOpen = (codfuncionario, nome) => {
        this.setState({
            open: true,
            selectedId: codfuncionario,
            selectedDesc: nome
        });
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de confirmação da exclusão */
    handleClose = () => {
        this.setState({
            open: false,
            selectedId: null,
            selectedDesc: ''
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Pesquisa os filtros na tela */
    onChangeSearch = (event) => {
        const { name, value } = event.target;

        const searchFilter = {
            ...this.state.searchFilter,
            [name]: (typeof value === 'string') ? value.toUpperCase() : value
        };

        this.setState({
            searchFilter,
            page: 0
        });
    };

    /* Pesquisa os cargos */
    onChangeCargos = (selected) => {
        this.setState({
            searchFilter: {
                ...this.state.searchFilter,
                cargos: selected
            },
            page: 0
        });
    };

    /* Limpa os filtros da tela */
    limpaFiltros = () => {
        const searchFilter = {
            nome: '',
            situacaoInativoFilter: ANAO,
            cargos: []
        };

        this.setState({
            searchFilter,
            page: 0
        }, this.loadFuncionarios);
    };

    render() {
        const {
            funcionarios,
            listaCargos,
            messageAlert,
            open,
            openAlert,
            page,
            rowsPerPage,
            searchFilter,
            selectedDesc,
            selectedId,
            totalItems
        } = this.state;

        const {
            actionIcon,
            addButton,
            filterPaper,
            iconGroup,
            redText
        } = this.estilo;

        const basePath = this.props.match?.url || '';

        return (
            <div style={this.estilo}>
                <Paper
                    style={{
                        ...filterPaper,
                        width: '100%'
                    }}
                >
                    <Input
                        autoFocus
                        id="nome"
                        name="nome"
                        onChange={this.onChangeSearch}
                        placeholder="Nome"
                        value={searchFilter.nome}
                        style={{
                            flex: '0 1 220px',
                            minWidth: 220
                        }}
                    />

                    <Box
                        style={{
                            flex: '0 1 220px',
                            minWidth: 220,
                            marginBottom: 16
                        }}
                    >
                        <ComboPadraoMultiple
                            options={searchFilter.cargos || []}
                            label="Cargos"
                            itens={listaCargos}
                            onSelectionChange={this.onChangeCargos}
                        />
                    </Box>

                    <Select
                        id="situacaoInativoFilter"
                        name="situacaoInativoFilter"
                        value={searchFilter.situacaoInativoFilter || ''}
                        onChange={this.onChangeSearch}
                        style={{
                            flex: '0 1 100px',
                            minWidth: 100,
                            textAlign: 'center'
                        }}
                    >
                        <MenuItem
                            value={ANAO}
                            style={{ justifyContent: 'center' }}
                        >
                            Ativos
                        </MenuItem>

                        <MenuItem
                            value={ASIM}
                            style={{ justifyContent: 'center' }}
                        >
                            Inativos
                        </MenuItem>

                        <MenuItem
                            value={'T'}
                            style={{ justifyContent: 'center' }}
                        >
                            Todos
                        </MenuItem>
                    </Select>

                    <span style={iconGroup}>
                        <Tooltip title="Procurar">
                            <Search
                                onClick={this.loadFuncionarios}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>

                        <Tooltip title="Limpar">
                            <BackspaceOutlined
                                onClick={this.limpaFiltros}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>
                    </span>

                    <div style={{ flex: 1 }} />

                    <Button
                        component={Link}
                        to={`${basePath}/novo`}
                        variant="contained"
                        color="primary"
                        style={addButton}
                    >
                        Novo
                    </Button>
                </Paper>

                <br />

                <Card>
                    <CardContent>
                        <PerfectScrollbar>
                            <div>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">
                                                Código
                                            </TableCell>

                                            <TableCell align="center">
                                                Nome
                                            </TableCell>

                                            <TableCell align="center">
                                                Cargo
                                            </TableCell>

                                            <TableCell align="center">
                                                Ações
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {funcionarios.length === 0 && (
                                            <TableRow>
                                                <TableCell
                                                    align="center"
                                                    colSpan={4}
                                                >
                                                    Nenhum funcionário encontrado
                                                </TableCell>
                                            </TableRow>
                                        )}

                                        {funcionarios.map(funcionario => (
                                            <TableRow
                                                hover
                                                key={funcionario.codfuncionario}
                                            >
                                                <TableCell
                                                    align="center"
                                                    style={(funcionario.inativo === ASIM) ? redText : {}}
                                                >
                                                    {funcionario.codfuncionario}
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    style={(funcionario.inativo === ASIM) ? redText : {}}
                                                >
                                                    {funcionario.nome}
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    style={(funcionario.inativo === ASIM) ? redText : {}}
                                                >
                                                    {funcionario.cargo}
                                                </TableCell>

                                                <TableCell align="center">
                                                    <span style={iconGroup}>
                                                        <Tooltip title="Editar">
                                                            <Link to={`${basePath}/${funcionario.codfuncionario}`}>
                                                                <EditTwoTone
                                                                    onMouseEnter={this.handleIconMouseEnter}
                                                                    onMouseLeave={this.handleIconMouseLeave}
                                                                    style={actionIcon}
                                                                />
                                                            </Link>
                                                        </Tooltip>

                                                        <Tooltip title="Visualizar">
                                                            <Link to={`${basePath}/${funcionario.codfuncionario}/view`}>
                                                                <VisibilityOutlined
                                                                    onMouseEnter={this.handleIconMouseEnter}
                                                                    onMouseLeave={this.handleIconMouseLeave}
                                                                    style={actionIcon}
                                                                />
                                                            </Link>
                                                        </Tooltip>

                                                        <Tooltip title="Excluir">
                                                            <DeleteForeverOutlined
                                                                onClick={() => this.handleOpen(
                                                                    funcionario.codfuncionario,
                                                                    funcionario.nome
                                                                )}
                                                                onMouseEnter={this.handleDeleteIconMouseEnter}
                                                                onMouseLeave={this.handleIconMouseLeave}
                                                                style={actionIcon}
                                                            />
                                                        </Tooltip>
                                                    </span>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </PerfectScrollbar>

                        <TablePagination
                            component="div"
                            count={totalItems}
                            onPageChange={this.handleChangePage}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            rowsPerPageOptions={[10, 50, 100, 200]}
                            labelRowsPerPage="Registros por página"
                        />
                    </CardContent>
                </Card>

                <DeleteConfirmationModal
                    open={open}
                    itemId={selectedId}
                    message={`Confirma exclusão do funcionário ${selectedDesc || ''} [${selectedId}]?`}
                    handleClose={this.handleClose}
                    handleDelete={this.handleConfirmDelete}
                />

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

export default FuncionarioList;